// import React, { useState } from "react";
// import {
//   Button,
//   CustomCheckbox,
//   FormFieldSet,
//   Modal,
//   ToggleButton,
// } from "../../../../../components";

// const JobPosting = () => {
//   const [showConnectMonsterModal, SetShowConnectMonsterModal] = useState(false);
//   const [showSettingsModal, SetShowSettingsModal] = useState(false);

//   const options = [
//     { label: "Option 1", value: "option1" },
//     { label: "Option 2", value: "option2" },
//     { label: "Option 3", value: "option3" },
//     { label: "Option 4", value: "option4" },
//   ];

//   const formFields = [
//     {
//       title: "Username",
//       placeholder: "Enter Username",
//       type: "text",
//       required: true,
//     },
//     {
//       title: "Display name",
//       placeholder: "Enter Display Name",
//       type: "text",
//       required: true,
//     },
//     {
//       title: "CAT",
//       placeholder: "Enter CAT",
//       type: "text",
//       required: true,
//     },
//     {
//       title: "Subscription (Annually)",
//       placeholder: "Enter Subscription",
//       type: "text",
//       required: true,
//     },
//     {
//       title: "Available",
//       placeholder: "Enter Available",
//       type: "text",
//       value: "0",
//       disabled: true,
//     },
//     {
//       title: "Downloaded",
//       placeholder: "Enter Downloaded",
//       type: "text",
//       disabled: true,
//     },
//   ];

//   return (
//     <div>
//       <div className="flex justify-end items-end mb-3 gap-3">
//         <Button
//           title="Settings"
//           size="sm"
//           variant="outlined"
//           onClick={() => SetShowSettingsModal(true)}
//         />
//         <Button
//           title="Connect Monster"
//           size="sm"
//           //   icon={"place_item"}
//           onClick={() => SetShowConnectMonsterModal(true)}
//         />
//       </div>
//       <p>
//         Welcome to the Monster Job posting integration process! Connecting your
//         monster with Tektree Inc. Enables you to effortlessly publish job
//         posting directly from Tektree to Monster's platform.
//       </p>
//       <div className="font-bold mt-5 mb-2">
//         Here are the steps to configure the Integrations
//       </div>
//       <ol className="list-decimal list-inside">
//         <li>
//           Click on <b>"Connect Monster"</b> and provide the necessary details:
//           Username, Password, CAT, Display name.
//         </li>

//         <li>Save the entered information to add your account successfully.</li>
//         <li>
//           Once saved, you can allocate credits to your team for utilization.
//         </li>
//         <li>Embark on your Recruitment Journey</li>
//       </ol>
//       <Modal
//         title="Add Account"
//         isOpen={showConnectMonsterModal}
//         onClose={() => SetShowConnectMonsterModal(false)}
//         width="max-w-4xl"
//         titleColor={"warning"}
//       >
//         {/* <div className="grid grid-cols-3 justify-center gap-4 py-5">
//           <FormFieldSet
//             type="text"
//             title={"Username"}
//             placeholder="Enter Username"
//             // value={excelFile}
//             // onChange={setExcelFile}
//             required
//           />
//           <FormFieldSet
//             type="text"
//             title={"Display name"}
//             placeholder="Enter Display Name"
//             required
//           />
//           <FormFieldSet
//             type="text"
//             title={"CAT"}
//             placeholder="Enter CAT"
//             required
//           />
//           <FormFieldSet
//             type="text"
//             title={"Subscription (Annually)"}
//             placeholder="Enter Subscription"
//             required
//           />
//           <FormFieldSet
//             type="text"
//             title={"Available"}
//             value="0"
//             placeholder="Enter Available"
//             disabled
//           />
//           <FormFieldSet
//             type="text"
//             title={"Downloaded"}
//             placeholder="Enter Downloaded"
//             disabled
//           />
//         </div> */}
//         <div className="grid grid-cols-3 gap-4 py-5">
//           {formFields.map((field, index) => (
//             <FormFieldSet
//               key={index}
//               type={field.type}
//               title={field.title}
//               placeholder={field.placeholder}
//               required={field.required}
//               value={field.value}
//               disabled={field.disabled}
//               // You can also add:
//               // onChange={(e) => handleInputChange(field.title, e.target.value)}
//             />
//           ))}
//         </div>

//         <div>
//           <CustomCheckbox
//             list
//             color="warning"
//             options={[
//               {
//                 label:
//                   "Create candidate/pipeline directly (if applied through Monster) ",
//                 value: "option1",
//               },
//             ]}
//             // selectedValues={item.selectedCheckboxValues}
//             multiple
//           />
//         </div>
//         <div className="flex justify-end gap-5 mt-5">
//           <Button
//             title={"Cancel"}
//             variant="outlined"
//             onClick={() => SetShowConnectMonsterModal(false)}
//           />
//           <Button
//             title={"Save"}
//             // onClick={() => setShowUploadModal(false)}
//           />
//         </div>
//       </Modal>
//       <Modal
//         title="Settings"
//         isOpen={showSettingsModal}
//         onClose={() => SetShowSettingsModal(false)}
//         width="max-w-4xl"
//         titleColor={"warning"}
//       >
//         <div className="w-1/3 px-3">
//           <FormFieldSet
//             type="multiSelect"
//             title="Location purchased"
//             placeholder="select Options"
//             showSearch
//             showSelectAll={true}
//             shadow={true}
//             options={options}
//             value="option 1"
//           />
//           <div className="mt-5 pl-2">
//             <div className="grid grid-cols-2 font-medium mb-2 text-sm">
//               <span>Role</span>
//               <span>Access</span>
//             </div>
//             <div className="space-y-2">
//               {["Admin", "Owner", "Anyone"].map((role, idx) => (
//                 <div key={idx} className="grid grid-cols-2 items-center">
//                   <span>{role}</span>
//                   <ToggleButton
//                     // size={size}
//                     // onChange={onChange}
//                     // label={label}
//                     // disabled={disabled}
//                     // labelPosition={labelPosition}
//                     isChecked={false}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//         <div className="flex justify-end gap-5 mt-5">
//           <Button
//             title={"Cancel"}
//             variant="outlined"
//             onClick={() => SetShowSettingsModal(false)}
//           />
//           <Button
//             title={"Save"}
//             // onClick={() => setShowUploadModal(false)}
//           />
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default JobPosting;

import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  ToggleButton,
} from "../../../../../components";
import AddAccountModel from "../../Modals/AddAccountModel";

const JobPosting = ({ category, type, integrations, onUpdate, selectedModule }) => {
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const integrationKey = `${category}-${type}`;
  const integration = integrations[integrationKey];

  // Get service name and settings availability from config
  const getServiceConfig = () => {
    const configs = {
      3: {
        1: { name: "Monster", hasSettings: true },
        2: { name: "Shine", hasSettings: true },
        3: { name: "Naukri", hasSettings: false },
        4: { name: "LinkedIn", hasSettings: true },
        5: { name: "ZipRecruiter", hasSettings: false },
        6: { name: "Jora", hasSettings: false },
      },
      11: {
        1: { name: "G-suite", hasSettings: true },
        2: { name: "Outlook", hasSettings: true },
        3: { name: "Mailgun", hasSettings: false },
        4: { name: "AWS SES", hasSettings: false },
        5: { name: "Instantly", hasSettings: false },
      },
      1: {
        1: { name: "VOIP Office CRM", hasSettings: true },
        2: { name: "ZOOM", hasSettings: false },
      },
      2: {
        1: { name: "VOIP Office CRM", hasSettings: false },
      },
      7: {
        1: { name: "Google Search API", hasSettings: false },
      },
    };
    return configs[category]?.[type] || { name: "Service", hasSettings: false };
  };

  const serviceConfig = getServiceConfig();

  const options = [
    { label: "India", value: "india" },
    { label: "USA", value: "usa" },
    { label: "UK", value: "uk" },
    { label: "Canada", value: "canada" },
  ];

  if (selectedModule === "bs") {
    return (
        <div className="mt-3">
          <p>This feature is not available for Bench Sales. However, you can configure the following features:</p>
          <div className="ms-3">
            <h6 className="text-dark my-2 -ms-1">Available Features for Bench Sales:</h6>
            <p>1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt; Kult AI (Text) &gt; Setup / Configure</p>
            <p>2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt; Apollo &gt; Setup / Configure</p>
            <p>3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt; G-Suite &gt; Setup / Configure</p>
            <p>4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt; Outlook &gt; Setup / Configure</p>
          </div>
        </div>
      );
  }

  return (
    <div>
      <div className="flex justify-end items-center mb-3 gap-3">
        {serviceConfig.hasSettings && (
          <Button
            title="Settings"
            size="sm"
            variant="outlined"
            onClick={() => setShowSettingsModal(true)}
          />
        )}
        <div className="w-[120px]">
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Select"
            size="sm"
            options={[
              { label: "Monster", value: 1 },
              { label: "Foundit", value: 2 },
              { label: "Linkedin", value: 3 },
              { label: "Naukri", value: 4 },
              { label: "Jora", value: 5 },
            ]}
            shadow={true}
          />
        </div>
        <Button
          title={`Connect ${serviceConfig.name}`}
          size="sm"
          onClick={() => setShowConnectModal(true)}
        />
      </div>
      <p>
        Welcome to the {serviceConfig.name} Job posting integration process!
        Connecting your {serviceConfig.name} with Tektree Inc. Enables you to
        effortlessly publish job posting directly from Tektree to{" "}
        {serviceConfig.name}'s platform.
      </p>
      <div className="font-bold mt-5 mb-2">
        Here are the steps to configure the Integrations
      </div>
      <ol className="list-decimal list-inside">
        <li>
          Click on <b>"Connect {serviceConfig.name}"</b> and provide the
          necessary details.
        </li>
        <li>Save the entered information to add your account successfully.</li>
        <li>
          Once saved, you can allocate credits to your team for utilization.
        </li>
        <li>Embark on your Recruitment Journey</li>
      </ol>

      <AddAccountModel
        isOpen={showConnectModal}
        onClose={() => setShowConnectModal(false)}
        category={category}
        type={type}
        existingData={integration}
        onSave={onUpdate}
        isEditMode={!!integration}
      />

      <Modal
        title="Settings"
        isOpen={showSettingsModal}
        onClose={() => setShowSettingsModal(false)}
        width="max-w-4xl"
        titleColor="primary"
      >
        <div className="w-1/3 px-3">
          <FormFieldSet
            type="multiSelect"
            title="Location purchased"
            placeholder="select Options"
            showSearch
            showSelectAll={true}
            shadow={true}
            options={options}
          />
          <div className="mt-5 pl-2">
            <div className="grid grid-cols-2 font-medium mb-2 text-sm">
              <span>Role</span>
              <span>Access</span>
            </div>
            <div className="space-y-2">
              {["Admin", "Owner", "Anyone"].map((role, idx) => (
                <div key={idx} className="grid grid-cols-2 items-center">
                  <span>{role}</span>
                  <ToggleButton isChecked={false} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-5 mt-5">
          <Button
            title="Cancel"
            variant="outlined"
            onClick={() => setShowSettingsModal(false)}
          />
          <Button title="Save" />
        </div>
      </Modal>
    </div>
  );
};

export default JobPosting;
